import { createContext, useState } from "react";

export const DataContext = createContext();

export const DataContextProvider = ({ children }) => {
    const [dataSelecionada, setDataSelecionada] = useState(null);

    return (
        <DataContext.Provider value={{ dataSelecionada, setDataSelecionada }}>
            {children}
        </DataContext.Provider>
    );
}